function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(252, 250, 249)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black': 'rgb(34, 34, 34)','blue': 'rgb(74, 144, 217)','bright-green': 'rgb(76, 175, 80)','bright-yellow': 'rgb(255, 227, 108)','charcoal': 'rgb(74, 74, 74)','cool-light-grey': 'rgb(224, 223, 223)','dark-grey': 'rgb(166, 166, 171)','dark-navy': 'rgb(10, 21, 48)','dark-pink': 'rgb(250, 152, 179)','ivory': 'rgb(255, 255, 240)','light-blue': 'rgb(206, 231, 254)','light-pink': 'rgb(253, 207, 222)','lilac': 'rgb(232, 208, 243)','mint': 'rgb(178, 235, 212)','navy': 'rgb(0, 31, 91)','navy-blue': 'rgb(10, 31, 68)','off-white': 'rgb(245, 240, 232)','red': 'rgb(217, 48, 37)','soft-pinks': 'rgb(249, 200, 213)','soft-yellow': 'rgb(249, 238, 151)','warm-blush-pink': 'rgb(252, 223, 229)','warm-light-grey': 'rgb(230, 225, 221)',};

    this.images = {'bright-colours': 'url("//littletalltales.com/cdn/shop/files/Bright_Colours_120x.png?v=7723667795679126212")','two-colours-add-note': 'url("//littletalltales.com/cdn/shop/files/scheme-2_7ab54a1e-583d-4bea-9a9b-a4d48f1182f9_120x.png?v=9485774434775214569")','rainbow': 'url("//littletalltales.com/cdn/shop/files/Rainbow_Colours_120x.png?v=17573535689659135471")','red-and-brown': 'url("//littletalltales.com/cdn/shop/files/Red_and_Brown_120x.png?v=16420709822740470552")','red-and-blue': 'url("//littletalltales.com/cdn/shop/files/Red_Blue_Swatch_120x.png?v=4890815139945616124")',};

    this.triggers = ['colour scheme','colour','couleur','farbe','cor','balloon colour','cloud colour','fairy colour',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
